<script>
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor.vue';
import { sanitizeForFacebookTemplate } from './facebookTemplateSanitizationHelper';

export default {
  components: { WootMessageEditor },
  props: {
    modelValue: {
      type: String,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(newValue) {
        this.handleInput(newValue);
      },
    },
  },
  methods: {
    handleInput(value) {
      const sanitizedValue = sanitizeForFacebookTemplate(value);

      this.$emit('update:modelValue', sanitizedValue);
    },
  },
};
</script>

<template>
  <WootMessageEditor
    v-model="internalValue"
    enable-variables
    class="bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 border-slate-200 border dark:border-slate-600 rounded-[0.3125rem] p-2 ml-[0.625rem] flex-1 !w-[28.175rem]"
  />
</template>

<style scoped lang="scss">
// Prosemirror does not have a native way of hiding the menu bar, hence
::v-deep .ProseMirror-menubar {
  @apply hidden;
}
::v-deep .ProseMirror.ProseMirror-woot-style {
  min-height: 1.4375rem !important;
  max-height: 5rem !important;

  p {
    @apply my-0 text-base leading-normal;
  }
}
</style>
